'use client'
import { envs } from '@config'
import { datadogRum } from '@datadog/browser-rum'

if (envs.ddEnv === 'production' || envs.ddEnv === 'staging') {
  datadogRum.init({
    applicationId: envs.ddApplicationId,
    clientToken: envs.ddClientToken,
    site: envs.ddSite,
    service: envs.ddService,
    env: envs.ddEnv,
    version: envs.ddVersion,
    sessionSampleRate: 20,
    sessionReplaySampleRate: envs.ddEnv === 'production' ? 10 : 0,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    traceSampleRate: 100,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [
      envs.graphqlHttpUrl,
      envs.cerberusApiUrl,
      envs.graphqlWsUrl,
      envs.restApiUrl,
    ],
  })
}

export { datadogRum }
